import { render, staticRenderFns } from "./DashboardVideostream.vue?vue&type=template&id=5a2abed0"
import script from "./DashboardVideostream.vue?vue&type=script&lang=js"
export * from "./DashboardVideostream.vue?vue&type=script&lang=js"
import style0 from "./DashboardVideostream.vue?vue&type=style&index=0&id=5a2abed0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports